import React from 'react';
import { Search } from 'lucide-react';
import { Action, Empty, LoadState, Status } from '../ui';

export function filterBusinesses(businesses, filter) {
  if (filter === 'all') return businesses;
  return businesses.filter(business => business.approval === filter);
}

export const ApprovalFilters = ({ businesses, filter, setFilter }) => <div className="filter-tabs">
  {['pending', 'approved', 'rejected', 'all'].map(status => <button
    data-testid={`approval-filter-${status}`} key={status} className={filter === status ? 'active' : ''}
    onClick={() => setFilter(status)}>{status}<span>{filterBusinesses(businesses, status).length}</span>
  </button>)}
</div>;

const BusinessRow = ({ business, onReview }) => <tr data-testid={`business-row-${business.id}`}>
  <td><strong>{business.company}</strong><small className="table-sub">{business.email}{business.demo ? ' · Demo' : ''}</small></td>
  <td className="mono">{business.tax_id}<small className="table-sub">{business.city}, IN</small></td>
  <td>{business.role}</td>
  <td><Status value={business.approval} id={`business-status-${business.id}`} /></td>
  <td><Action id={`review-business-${business.id}`} secondary onClick={() => onReview(business)}><Search size={14} />Review</Action></td>
</tr>;

export const BusinessList = ({ remote, rows, filter, onReview }) => {
  if (remote.loading || remote.error) return <LoadState remote={remote} />;
  if (!rows.length) return <Empty title={`No ${filter === 'all' ? '' : filter} applications`}
    text="New business applications will appear here." />;
  return <div className="table-scroll"><table data-testid="business-approval-table">
    <thead><tr><th>Business</th><th>Tax ID / Location</th><th>Role</th><th>Status</th><th /></tr></thead>
    <tbody>{rows.map(business => <BusinessRow key={business.id} business={business} onReview={onReview} />)}</tbody>
  </table></div>;
};